import React, { Component } from "react";
import Moment, { diff } from "moment";

import { Popover } from "../../actions/Tippy";
import TimeCounterMinute from "../../containers/TimeCounterMinute";
import { Topover, Tooltippy } from "../../actions/Tippy";
import UserPhoto from "../UserPhoto/userphoto";
import Typography from "../Typography";

import DEFAULT from "../../build/images/user.svg";
import CLIENTE from "../../build/images/cliente.svg";
import FACEBOOK from "../../build/images/facebook_new.svg";
import WHATSAPP from "../../build/images/whatsapp_new.svg";
import TELEGRAM from "../../build/images/telegram-new.svg";
import GOOGLEGBM from "../../build/images/googlegbm-new.svg";
import PHONE from "../../build/images/callchat-new.svg";
import WEBCHAT from "../../build/images/webchat-new.svg";
import INSTAGRAM from "../../build/images/instagram_new.svg";
import EMAIL from "../../build/images/email-new.svg";
import TEAMS from "../../build/images/channelsNew/teamsBig.svg";

import { ReactComponent as SMSICON } from "../../build/images/sms-new.svg";
import { ReactComponent as ActionIcon } from "../../build/images/more.svg";
import { ReactComponent as Call } from "../../build/images/teams/call.svg";
import { ReactComponent as Calendar } from "../../build/images/teams/calendar.svg";
import { ReactComponent as InfoCircle } from "../../build/images/info-circle.svg";
import { ReactComponent as Attention } from "../../build/images/danger.svg";
import { ReactComponent as Timer } from "../../build/images/timer.svg";
import { ReactComponent as HappyRating } from "../../build/images/icons-rating/happy.svg";
import { ReactComponent as IndifRating } from "../../build/images/icons-rating/indifferent.svg";
import { ReactComponent as SadRating } from "../../build/images/icons-rating/sad.svg";
import { ReactComponent as NullRating } from "../../build/images/icons-rating/star-slash.svg";

import "./queue-section.css";

import _ from "lodash";
import { filtrarTroncosParaOCallback } from "../../utils/filtrarTroncosParaOCallback";
const { connection_platform } = require("../../services/api");

var ipcurrent = "";
var gethostname = window.location.hostname;
var pathname = "";
var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

class QueueItem extends Component {
  renderPopoverInfo2 = (e, info) => (
    <div className="context-menu" id="qtd-retorno">
      {(() => {
        if (info) {
          let array = info.split(";");
          array.pop();
          return (
            <ul className="context-menu__list">
              {array.map((todo) => {
                let position = todo.split("-");
                return (
                  <li className="context-menu__item">
                    <div className="container-tippy-return">
                      <div className="tippyTxt">
                        {position[2] ? position[1] : position[0]}
                      </div>

                      <div className="item-tippy-return">
                        <i className="material-icons">date_range</i>{" "}
                        {position[2] ? position[0] : ""}
                      </div>

                      <div className="info-return">
                        <span>Motivo: </span>
                        {position[2] ? position[2] : position[1]}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          );
        }
      })()}
    </div>
  );

  renderPopoverInfo = (e, ip, file) => (
    <>
      {file ? (
        <div className="img">
          <img
            src={
              file ? connection_platform.type_connect + "://" + ip + file : null
            }
            width="100"
            alt=""
          />
        </div>
      ) : (
        ""
      )}
    </>
  );

  renderAvaliation = (queue) => {
    switch (queue.score_class) {
      case "otimo":
        return (
          <Tooltippy content={queue.score_value} placement="top">
            <div className="user-rating__tag happy">
              <HappyRating />
              Cliente satisfeito
            </div>
          </Tooltippy>
        );

      case "promotor":
        return (
          <Tooltippy content={queue.score_value} placement="top">
            <div className="user-rating__tag happy">
              <HappyRating />
              Cliente satisfeito
            </div>
          </Tooltippy>
        );

      case "razoavel":
        return (
          <Tooltippy content={queue.score_value} placement="top">
            <div className="user-rating__tag indifferent">
              <IndifRating />
              Cliente indiferente
            </div>
          </Tooltippy>
        );

      case "neutro":
        return (
          <Tooltippy content={queue.score_value} placement="top">
            <div className="user-rating__tag indifferent">
              <IndifRating />
              Cliente indiferente
            </div>
          </Tooltippy>
        );

      case "ruim":
        return (
          <Tooltippy content={queue.score_value} placement="top">
            <div className="user-rating__tag sad">
              <SadRating />
              Cliente insatisfeito
            </div>
          </Tooltippy>
        );

      case "detrator":
        return (
          <Tooltippy content={queue.score_value} placement="top">
            <div className="user-rating__tag sad">
              <SadRating />
              Cliente insatisfeito
            </div>
          </Tooltippy>
        );

      default:
        return (
          <div className="user-rating__tag">
            <NullRating />
            Nenhuma avaliação
          </div>
        );
    }
  };

  render() {
    const {
      queue,
      IPCurrent,
      InfoUsers,
      SolicitarChamadaAtiva,
      SolicitarChamada,
      PermissionRouter,
      StatusAgent,
      AtdSimult,
      OutBandService,
      renderPopover,
      buttonDetails,
      expandQueue,
      checkExpandQueue,
      ShowInfoDisplay,
      callpark,
    } = this.props;

    let now;
    let antes;
    let days;
    let duracao = 0;
    let checkItem = false;

    return (
      <div className="item queue-item">
        <div
          className="photo-channel"
          onClick={(event) => checkExpandQueue(event, queue.queueid)}
        >
          {(() => {
            if (
              queue.pathfile === "  " ||
              queue.pathfile === " " ||
              queue.pathfile === null
            ) {
              // return <img src={DEFAULT} alt="" />;
              return (
                <UserPhoto
                  size="large"
                  letterIcon={
                    queue.contactname && queue.contactname !== " "
                      ? createJSON(queue.contactname)
                      : _.upperFirst(queue.caller)
                  }
                />
              );
            } else {
              return (
                <Topover
                  interactive={true}
                  content={this.renderPopoverInfo(
                    this,
                    ipcurrent,
                    queue.pathfile
                  )}
                >
                  <UserPhoto
                    size="large"
                    link={
                      queue.pathfile
                        ? connection_platform.type_connect +
                          "://" +
                          ipcurrent +
                          queue.pathfile
                        : null
                    }
                    letterIcon={
                      queue.contactname && queue.contactname !== " "
                        ? createJSON(queue.contactname)
                        : _.upperFirst(queue.caller)
                    }
                  />
                  {/* <img
                        src={
                          queue.pathfile
                            ? connection_platform.type_connect +
                              "://" +
                              ipcurrent +
                              queue.pathfile
                            : null
                        }
                        alt=""
                      /> */}
                </Topover>
              );
            }
          })()}

          {(() => {
            switch (parseInt(queue.mediaid)) {
              case 1:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={PHONE}
                    alt=""
                  />
                );
              case 2:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={WEBCHAT}
                    alt=""
                  />
                );
              case 3:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={EMAIL}
                    alt=""
                  />
                );
              case 4:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={FACEBOOK}
                    alt=""
                  />
                );
              case 5:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={WHATSAPP}
                    alt=""
                  />
                );
              case 6:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={INSTAGRAM}
                    alt=""
                  />
                );
              case 8:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={TELEGRAM}
                    alt=""
                  />
                );
              case 11:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={GOOGLEGBM}
                    alt=""
                  />
                );
              case 12:
                return <SMSICON />;
              case 15:
                return (
                  <img
                    className="prox-atend__enqueued-icon"
                    src={TEAMS}
                    alt=""
                  />
                );
              default:
                break;
            }
          })()}
        </div>
        <div className="inner">
          <div className="title">
            <div className="about-user">
              <div
                className="nome"
                id={queue.queueid}
                onClick={(event) => checkExpandQueue(event, queue.queueid)}
              >
                {/* {_.upperFirst(queue.caller)} */}
                <Tooltippy
                  content={
                    queue.contactname
                      ? queue.contactname !== " "
                        ? createJSON(queue.contactname)
                        : _.upperFirst(queue.caller)
                      : _.upperFirst(queue.caller)
                  }
                  placement="top-left"
                >
                  {/* <span
                    className="nome__text"
                    onClick={(event) => checkExpandQueue(event, queue.queueid)}
                  >
                    
                  </span> */}
                  <Typography.H4 className={"nome__text"} color={"gray-600"}>
                    {(() => {
                      if (queue.contactname) {
                        if (queue.contactname !== " ") {
                          return createJSON(queue.contactname);
                        } else {
                          return _.upperFirst(queue.caller);
                        }
                      } else {
                        return _.upperFirst(queue.caller);
                      }
                    })()}
                  </Typography.H4>
                </Tooltippy>
              </div>

              {/* <div className="criticidade normal" data-tippy="Normal">•</div> */}
            </div>

            <div className="user-rating">{this.renderAvaliation(queue)}</div>

            <div
              className="title__top new"
              onClick={(event) => checkExpandQueue(event, queue.queueid)}
            >
              {(() => {
                switch (parseInt(queue.status)) {
                  case 0:
                    return <span className="prox-atend__status">Callback</span>;
                  case 1:
                    return (
                      <span className="prox-atend__status">Fila de espera</span>
                    );
                  case 5:
                    return (
                      <span className="prox-atend__status">
                        {queue.username} está retornando...
                      </span>
                    );
                  case 2:
                    return (
                      <span className="prox-atend__status">
                        {queue.username} está retornando...
                      </span>
                    );
                  default:
                    return "";
                }
              })()}
            </div>

            <div className="title__subtop">
              {(() => {
                if (IPCurrent.difftime < 0) {
                  antes = Moment(queue.to_char, "DD/MM/YYYY HH:mm:ss").format(
                    "YYYY/MM/DD HH:mm:ss"
                  );
                  now = Moment()
                    .add(Math.round(IPCurrent.difftime), "seconds")
                    .format("YYYY/MM/DD HH:mm:ss");
                  duracao = Moment(now).diff(antes, "seconds");
                  checkItem = true;
                } else {
                  antes = Moment(queue.to_char, "DD/MM/YYYY HH:mm:ss").format(
                    "YYYY/MM/DD HH:mm:ss"
                  );
                  now = Moment()
                    .subtract(Math.round(IPCurrent.difftime), "seconds")
                    .format("YYYY/MM/DD HH:mm:ss");

                  duracao = Moment(now).diff(antes, "seconds");
                  checkItem = true;
                }

                days = Moment(now).diff(antes, "days");

                if (
                  buttonDetails ||
                  expandQueue.indexOf(queue.queueid) !== -1
                ) {
                  return;
                } else {
                  return (
                    <div
                      className={
                        parseInt(queue.status) === 1 && checkItem === true
                          ? "user-time active"
                          : "user-time"
                      }
                      onClick={(event) =>
                        checkExpandQueue(event, queue.queueid)
                      }
                    >
                      <Timer />
                      <span className="time">
                        <TimeCounterMinute
                          horario={duracao < 0 ? 0 : parseInt(duracao)}
                          day={days}
                          key={queue.queueid}
                        />{" "}
                      </span>
                    </div>
                  );
                }
              })()}
              {buttonDetails || expandQueue.indexOf(queue.queueid) !== -1 ? (
                ""
              ) : (
                <div
                  className={
                    parseInt(queue.status) !== 1
                      ? "user-date active"
                      : "user-date"
                  }
                  onClick={(event) => checkExpandQueue(event, queue.queueid)}
                >
                  <Calendar />
                  <span className="date">
                    {Moment(queue.to_char, "DD/MM/YYYY HH:mm:ss").format(
                      "DD/MM/YYYY HH:mm"
                    )}
                  </span>
                </div>
              )}
            </div>
          </div>
          <div
            className={
              buttonDetails || expandQueue.indexOf(queue.queueid) !== -1
                ? "details active"
                : "details"
            }
          >
            <div className="details__text">
              <Call />
              <span>{queue.caller}</span>
            </div>
            <div className="pct100  details__text">
              <Attention />
              <Tooltippy content={queue.called}>
                <span>{queue.called}</span>
              </Tooltippy>
            </div>
            <div className="pct100  details__text">
              <Calendar />
              <span>{queue.to_char}</span>
            </div>
            <div className={"user-time active details__text"}>
              <Timer />
              <span className="time">
                <TimeCounterMinute
                  horario={duracao < 0 ? 0 : parseInt(duracao)}
                  day={days}
                  key={queue.queueid}
                />{" "}
              </span>
            </div>

            <div className="pct100  details__text">
              <span>Qtd. de tentativas: ({queue.recv_count})</span>
            </div>
            <Popover
              interactive={true}
              boundary="window"
              placement="left"
              content={this.renderPopoverInfo2(this, queue.obs)}
            >
              <div
                className="pct100  details__text qtd-retorno tippy-context-menu"
                data-tippy-placement="right"
                data-template="qtd-retorno"
              >
                <span className="details__text-qtd">
                  Qtd. de retornos: ({queue.callback_count})
                </span>
              </div>
            </Popover>
          </div>
        </div>
        <div
          className="actions-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <div className="actions">
            {(() => {
              switch (parseInt(queue.status)) {
                case 0:
                  const filteredPermissionRouter = filtrarTroncosParaOCallback(
                    queue.scriptid,
                    PermissionRouter
                  );
                  return (
                    <div
                      data-tippy="Atender chamada"
                      className="phone"
                      onClick={(event) => {
                        SolicitarChamadaAtiva(
                          event,
                          PermissionRouter,
                          queue.mediaid,
                          StatusAgent.status,
                          InfoUsers,
                          queue.caller,
                          OutBandService,
                          queue,
                          AtdSimult,
                          IPCurrent,
                          StatusAgent
                        );
                        ShowInfoDisplay("Clientes");
                      }}
                    >
                      <Call />
                      <input
                        type="hidden"
                        id={"clickqueue_" + queue.queueid}
                        name={"clickqueue_" + queue.queueid}
                      />
                    </div>
                  );
                case 1:
                  return (
                    <div
                      data-tippy="Atender chamada"
                      className="phone"
                      onClick={
                        callpark === true
                          ? (event) => {
                              SolicitarChamada(
                                InfoUsers,
                                queue.scriptid,
                                queue.cdrid,
                                queue.mediaid,
                                StatusAgent.status,
                                StatusAgent
                              );
                              ShowInfoDisplay("Clientes");
                            }
                          : () => {}
                      }
                    >
                      <Call />
                    </div>
                  );
                default:
                  return (
                    <div
                      data-tippy="Atender chamada"
                      className="phone"
                      onClick={(event) => {
                        SolicitarChamadaAtiva(
                          event,
                          PermissionRouter,
                          queue.mediaid,
                          StatusAgent.status,
                          InfoUsers,
                          queue.caller,
                          OutBandService,
                          queue,
                          AtdSimult,
                          IPCurrent,
                          StatusAgent
                        );
                        ShowInfoDisplay("Clientes");
                      }}
                    >
                      <Call />
                      <input
                        type="hidden"
                        id={"clickqueue_" + queue.queueid}
                        name={"clickqueue_" + queue.queueid}
                      />
                    </div>
                  );
              }
            })()}
            <Popover
              trigger="click"
              boundary="window"
              placement="right"
              multiple={true}
              interactive={true}
              content={renderPopover(
                this,
                queue.caller,
                queue.contactname,
                queue.cdrid,
                queue.queueid,
                queue,
                InfoUsers
              )}
            >
              <div
                className="info tippy-context-menu"
                data-tooltip="Mais informações"
                data-template="info-fila"
              >
                <InfoCircle />
              </div>
            </Popover>
            {(() => {
              if (InfoUsers.supervisor === true)
                return (
                  <Popover
                    trigger="click"
                    boundary="window"
                    placement="right"
                    multiple={true}
                    interactive={true}
                    content={renderPopover(
                      this,
                      queue.caller,
                      queue.contactname,
                      queue.cdrid,
                      queue.queueid,
                      queue,
                      InfoUsers,
                      true
                    )}
                  >
                    <div
                      className="action tippy-context-menu"
                      data-tooltip="Mais informações"
                      data-template="info-fila"
                    >
                      <ActionIcon />
                    </div>
                  </Popover>
                );
            })()}
          </div>
          {!!queue.unreadMessages && (
            <span className="actions-container__unreaded-messages">
              {queue.unreadMessages}
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default QueueItem;
